export default __webpack_public_path__ + "static/media/logo-small.adae4d83.svg";